import React from 'react'
import ToggleButtonComponent from '../../../shared/Dashboard/ToogleButton'
import { Box, Button, Typography } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList';
import DownloadIcon from '@mui/icons-material/Download';
import { isReadOnly } from '../../../utils/permissionUtils';

const PunchlistHeader = (props) => {
    const { handleDelete, active, setActive, view, setView, handleClearFilter, handleDownload, loading, selectedRows, open } = props
    return (
        <Box mb={view === "list view" ? 2 : 0} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", alignContent: "center" }}>
                <Box>
                    <Typography variant="span" fontSize={22} sx={{ fontWeight: "bold", pb: 2 }}>
                        QC Punchlist
                    </Typography>
                </Box>
                <ToggleButtonComponent
                    data={["list view", "map view"]}
                    active={view}
                    setActive={setView}
                />
            </Box>

            <Box sx={{ display: "flex", gap: 2, alignItems: "center", alignContent: "center" }}>
                <ToggleButtonComponent
                    data={["external", "internal"]}
                    active={active}
                    setActive={setActive}
                />

                {view === "list view" &&
                    <>
                        {selectedRows?.length ? <Button
                            variant='outlined'
                            onClick={() => handleDelete(!open)}
                        >
                            Delete Selected Rows
                        </Button> : ''}
                        <Button
                            variant="outlined"
                            startIcon={<FilterListIcon />}
                            onClick={handleClearFilter}
                        >
                            Clear Filter
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<DownloadIcon />}
                            onClick={handleDownload}
                            loading={loading}
                            disabled ={isReadOnly()}
                        >
                            Download
                        </Button>

                    </>
                }
            </Box>
        </Box>
    )
}

export default PunchlistHeader